export default ({ message, title, style = null }) => (
	<div className="alert alert-danger cb-alert-heading" role="alert" tabIndex="0" style={style}>
		<h2>{title || 'Submission Error'}</h2>
		<p style={{ marginBottom: 0 }}>{message}</p>
	</div>
)
